
export class AgencyMemberId {
  "AgencyMemberId": AgencyMemberId;
}
export class UserId {
  "UserId": UserId;
}

export class AgencyTeamId {
  "AgencyTeamId": AgencyTeamId;
}

export class AgencyApiUserId {
  "AgencyApiUserId": AgencyApiUserId;
}

export class AgencyId {
  "AgencyId": AgencyId;
  static wrap = (id: number): AgencyId => id as unknown as AgencyId;
  static unwrap = (id: AgencyId): number => id as unknown as number;
}

export class OfficeId {
  "OfficeId": OfficeId;
}

export class OfficeBranchId {
  "OfficeBranchId": OfficeBranchId;
}

export class CaregiverId {
  "CaregiverId": CaregiverId;
  static wrap = (id: number): CaregiverId => id as unknown as CaregiverId;
  static unwrap = (id: CaregiverId): number => id as unknown as number;
}

export class PatientId {
  "PatientId": PatientId;
  static wrap = (id: number): PatientId => id as unknown as PatientId;
  static unwrap = (id: PatientId): number => id as unknown as number;
}

export class ContractTypeId {
  "ContractTypeId": ContractTypeId;
}
export class PayerId {
  "PayerId": PayerId;
}
export class PatientDocumentId {
  "PatientDocumentId": PatientDocumentId;
}

export class PatientTaskInstanceId {
  "PatientTaskInstanceId": PatientTaskInstanceId;
}

export class VisitInstanceId {
  "VisitInstanceId": VisitInstanceId;
}

export class PatientDocumentTypeId {
  "PatientDocumentTypeId": PatientDocumentTypeId;
}

export class PatientDocumentVersionId {
  "PatientDocumentVersionId": PatientDocumentVersionId;
}

export class PatientTaskId {
  "PatientTaskId": PatientTaskId;
}

export class PatientContractDiagnosisCodeId {
  "PatientContractDiagnosisCodeId": PatientContractDiagnosisCodeId;
}

export class ICD10CodeId {
  "ICD10CodeId": ICD10CodeId;
}

export class PatientContractId {
  "PatientContractId": PatientContractId;
}

export class ServiceCodeId {
  "ServiceCodeId": ServiceCodeId;
}
export class PatientWeeklyTemplateShiftId {
  "PatientWeeklyTemplateShiftId": PatientWeeklyTemplateShiftId;
}

export class NoteId {
  "NoteId": NoteId;
}
export class MasterWeekId {
  "MasterWeekId": MasterWeekId;
}
export class VisitBatchId {
  "VisitBatchId": VisitBatchId;
}

export class VisitBroadcastId {
  "VisitBroadcastId": VisitBroadcastId;
}
export class NoteSubjectId {
  "NoteSubjectId": NoteSubjectId;
}

export class NotePredefinedAnswerId {
  "NotePredefinedAnswerId": NotePredefinedAnswerId;
}
export class PayrollCodeId {
  "PayrollCodeId": PayrollCodeId;
}

export class PatientTaskTemplateId {
  "PatientTaskTemplateId": PatientTaskTemplateId;
}

export class PlanOfCareTypeId {
  "PlanOfCareTypeId": PlanOfCareTypeId;
}

export class PlanOfCareId {
  "PlanOfCareId": PlanOfCareId;
}

export class PlanOfCareItemId {
  "PlanOfCareItemId": PlanOfCareItemId;
}

export class DutySheetId {
  "DutySheetId": DutySheetId;
}

export class PatientDocumentScheduleId {
  "PatientDocumentScheduleId": PatientDocumentScheduleId;
}

export class PlanOfCareDutyId {
  "PlanOfCareDutyId": PlanOfCareDutyId;
}

export class TimesheetId {
  "TimesheetId": TimesheetId;
}
export class PatientSurplusInvoiceId {
  "PatientSurplusInvoiceId": PatientSurplusInvoiceId;
}

export class CaregiverDocumentTypeId {
  "CaregiverDocumentTypeId": CaregiverDocumentTypeId;
  static wrap = (id: number): CaregiverDocumentTypeId => id as unknown as CaregiverDocumentTypeId;
  static unwrap = (id: CaregiverDocumentTypeId): number => id as unknown as number;
}

export class CaregiverComplianceInstanceId {
  "CaregiverComplianceInstanceId": CaregiverComplianceInstanceId;
}

export class ComplianceV2ItemFieldId {
  "ComplianceV2ItemFieldId": ComplianceV2ItemFieldId;
  static wrap = (id: number): ComplianceV2ItemFieldId => id as unknown as ComplianceV2ItemFieldId;
  static unwrap = (id: ComplianceV2ItemFieldId): number => id as unknown as number;
}

export class ComplianceV2ItemFieldPossibleValueId {
  "ComplianceV2ItemFieldPossibleValueId": ComplianceV2ItemFieldPossibleValueId;
  static wrap = (id: number): ComplianceV2ItemFieldPossibleValueId =>
    id as unknown as ComplianceV2ItemFieldPossibleValueId;
  static unwrap = (id: ComplianceV2ItemFieldPossibleValueId): number => id as unknown as number;
}

export class CaregiverDocumentUploadId {
  "CaregiverDocumentUploadId": CaregiverDocumentUploadId;
  static wrap = (id: number): CaregiverDocumentUploadId =>
    id as unknown as CaregiverDocumentUploadId;
  static unwrap = (id: CaregiverDocumentUploadId): number => id as unknown as number;
}

export class CertificationPeriodId {
  "CertificationPeriodId": CertificationPeriodId;
}

export class ComplianceReviewRecordId {
  "ComplianceReviewRecordId": ComplianceReviewRecordId;
  static wrap = (id: number): ComplianceReviewRecordId => id as unknown as ComplianceReviewRecordId;
  static unwrap = (id: ComplianceReviewRecordId): number => id as unknown as number;
}

export class ComplianceReviewDocumentId {
  "ComplianceReviewDocumentId": ComplianceReviewDocumentId;
  static wrap = (id: number): ComplianceReviewDocumentId =>
    id as unknown as ComplianceReviewDocumentId;
  static unwrap = (id: ComplianceReviewDocumentId): number => id as unknown as number;
}

export class ComplianceReviewQuestionId {
  "ComplianceReviewQuestionId": ComplianceReviewQuestionId;
  static wrap = (id: number): ComplianceReviewQuestionId =>
    id as unknown as ComplianceReviewQuestionId;
  static unwrap = (id: ComplianceReviewQuestionId): number => id as unknown as number;
}

export class ComplianceReviewQuestionOptionId {
  "ComplianceReviewQuestionOptionId": ComplianceReviewQuestionOptionId;
  static wrap = (id: number): ComplianceReviewQuestionOptionId =>
    id as unknown as ComplianceReviewQuestionOptionId;
  static unwrap = (id: ComplianceReviewQuestionOptionId): number => id as unknown as number;
}

export class ComplianceReviewRejectReasonId {
  "ComplianceReviewRejectReasonId": ComplianceReviewRejectReasonId;
  static wrap = (id: number): ComplianceReviewRejectReasonId =>
    id as unknown as ComplianceReviewRejectReasonId;
  static unwrap = (id: ComplianceReviewRejectReasonId): number => id as unknown as number;
}

export class ComplianceReviewApprovalConditionId {
  "ComplianceReviewApprovalConditionId": ComplianceReviewApprovalConditionId;
  static wrap = (id: number): ComplianceReviewApprovalConditionId =>
    id as unknown as ComplianceReviewApprovalConditionId;
  static unwrap = (id: ComplianceReviewApprovalConditionId): number => id as unknown as number;
}

export type CaregiverCertification =
  | "CBSA"
  | "CDPAP"
  | "CH"
  | "CMT"
  | "CNA"
  | "COMP"
  | "DCW"
  | "ESC"
  | "FS"
  | "GNA"
  | "HCSS"
  | "HHA"
  | "HM"
  | "HMK"
  | "HSK"
  | "ILST"
  | "LPN"
  | "MSW"
  | "NT"
  | "OT"
  | "PA"
  | "PBIS"
  | "PC"
  | "PCA"
  | "PT"
  | "PTA"
  | "RD"
  | "RESP"
  | "RN"
  | "RT"
  | "SCI"
  | "SCM"
  | "SDP"
  | "SHC"
  | "SHHA"
  | "SPC"
  | "ST";

export class HRSectionStageId {
  "HRSectionStageId": HRSectionStageId;
}

export class OfficeCaregiverHoursRestrictionOverrideId {
  "OfficeCaregiverHoursRestrictionOverrideId": OfficeCaregiverHoursRestrictionOverrideId;
}

export type Id =
  | AgencyMemberId
  | UserId
  | AgencyId
  | OfficeId
  | OfficeBranchId
  | CaregiverId
  | PatientId
  | ContractTypeId
  | PatientDocumentId
  | PatientTaskInstanceId
  | VisitInstanceId
  | PatientDocumentTypeId
  | PatientDocumentVersionId
  | PatientTaskId
  | PatientContractDiagnosisCodeId
  | ICD10CodeId
  | ServiceCodeId
  | MasterWeekId
  | NoteId
  | NoteSubjectId
  | NotePredefinedAnswerId
  | PayrollCodeId
  | VisitBatchId
  | VisitBroadcastId
  | PatientContractId
  | ServiceCodeId
  | PayrollCodeId
  | PatientTaskTemplateId
  | PlanOfCareTypeId
  | PlanOfCareId
  | PlanOfCareItemId
  | DutySheetId
  | PlanOfCareDutyId
  | PatientDocumentScheduleId
  | AgencyTeamId
  | PayerId
  | CaregiverDocumentUploadId
  | HRSectionStageId
  | ComplianceReviewRecordId
  | ComplianceReviewDocumentId
  | ComplianceReviewQuestionId
  | ComplianceReviewQuestionOptionId
  | PatientSurplusInvoiceId
  | OfficeCaregiverHoursRestrictionOverrideId;
